import { BACKEND_URL, BACKEND_URL_2 } from "actions/types";
import axios from "axios";
import store from "redux/store";

let saveHierarchy = null;
export const saveHierarchyFunc = async (value) => {
  const url = "org/edit-company-meta";
  if (saveHierarchy !== null) {
    saveHierarchy.cancel("New Call made");
    saveHierarchy = null;
  }
  saveHierarchy = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: saveHierarchy.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

let addDivision = null;
export const addDivisionFunc = async (value) => {
  const url = "project-management/create-team";
  if (addDivision !== null) {
    addDivision.cancel("New Call made");
    addDivision = null;
  }
  addDivision = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: addDivision.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

let editDivision = null;
export const editDivisionFunc = async (value) => {
  const url = "project-management/edit-team";
  if (editDivision !== null) {
    editDivision.cancel("New Call made");
    editDivision = null;
  }
  editDivision = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: editDivision.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

let deactivateUserid = null;
export const deactivateUseridFunc = async (value) => {
  const url = "project/edit-project-user-id";
  if (deactivateUserid !== null) {
    deactivateUserid.cancel("New Call made");
    deactivateUserid = null;
  }
  deactivateUserid = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: deactivateUserid.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

let deactivateProjectById = null;
export const deactivateProjectByIdFunc = async (value) => {
  const url = "project-management/delete-team";
  if (deactivateProjectById !== null) {
    deactivateProjectById.cancel("New Call made");
    deactivateProjectById = null;
  }
  deactivateProjectById = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: deactivateProjectById.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export const getOrderedUnifiedHierarchy = async (data, targetUuids) => {
  const nodeMap = data.reduce((map, node) => {
    map[node.id] = node;
    return map;
  }, {});

  const includedNodes = new Set();
  const markHierarchyForUuid = (uuid) => {
    const targetNode = data.find((node) => node.uuid === uuid);
    if (!targetNode) return;

    let currentNode = targetNode;
    while (currentNode) {
      includedNodes.add(currentNode.id);
      currentNode = currentNode.parent ? nodeMap[currentNode.parent] : null;
    }
  };
  targetUuids.forEach(markHierarchyForUuid);
  return data.filter((node) => includedNodes.has(node.id));
};

let sendEmailCompliance = null;
export const sendEmailComplianceFunc = async (value) => {
  const url = "operations/compose-email";
  if (sendEmailCompliance !== null) {
    sendEmailCompliance.cancel("New Call made");
    sendEmailCompliance = null;
  }
  sendEmailCompliance = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: sendEmailCompliance.token,
    });
    return response;
  } catch (error) {
    return null;
  }
};

let approveByEmail = null;
export const approveByEmailFunc = async (value) => {
  const url = "operations/approve-div-instance";
  if (approveByEmail !== null) {
    approveByEmail.cancel("New Call made");
    approveByEmail = null;
  }
  approveByEmail = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: approveByEmail.token,
    });
    return response;
  } catch (error) {
    console.error("Error in approveByEmailFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let donwloaduserLogs = null;

export const donwloaduserLogsFunc = async (value) => {
  const url = "metrics/user-login-reports";
  if (donwloaduserLogs !== null) {
    donwloaduserLogs.cancel("New Call made");
    donwloaduserLogs = null;
  }
  donwloaduserLogs = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: donwloaduserLogs.token,
    });
    return response;
  } catch (error) {
    console.error("Error in donwloaduserLogsFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let taskForDownloadUser = null;
export const taskForDownloadUserFunc = async (value) => {
  const url = "project-management/get-task-status";
  if (taskForDownloadUser !== null) {
    taskForDownloadUser.cancel("New Call made");
    taskForDownloadUser = null;
  }
  taskForDownloadUser = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: taskForDownloadUser.token,
    });
    return response;
  } catch (error) {
    console.error("Error in taskForDownloadUserFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let donwloadCertificate = null;

export const donwloadCertificateunc = async (value) => {
  const url = "metrics/list-instance-for-report";
  if (donwloadCertificate !== null) {
    donwloadCertificate.cancel("New Call made");
    donwloadCertificate = null;
  }
  donwloadCertificate = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: donwloadCertificate.token,
    });
    return response;
  } catch (error) {
    console.error("Error in donwloadCertificateunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let taskForDownloadCertificate = null;
export const taskForDownloadCertificateFunc = async (value) => {
  const url = "project-management/get-task-status";
  if (taskForDownloadCertificate !== null) {
    taskForDownloadCertificate.cancel("New Call made");
    taskForDownloadCertificate = null;
  }
  taskForDownloadCertificate = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: taskForDownloadCertificate.token,
    });
    return response;
  } catch (error) {
    console.error("Error in taskForDownloadCertificateFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

export const getTitleByUUID = (value) => {
  let projectList = store.getState().project.topProjectList;
  if (projectList.length > 0) {
    let title = projectList.filter((item) => item.uuid === value);
    return title.length > 0 ? title[0].title : value;
  }
  return value;
};

let bulkUpload = null;
export const bulkUploadFunc = async (value) => {
  const url = "project-management/upload-team-file";

  if (bulkUpload !== null) {
    bulkUpload.cancel("New Call made");
    bulkUpload = null;
  }
  bulkUpload = axios.CancelToken.source();

  const formData = new FormData();
  formData.append("file", value.file);
  formData.append("company", value.company);
  formData.append("category", value.category);

  try {
    const response = await axios.post(BACKEND_URL_2 + url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Important for file uploads
      },
      cancelToken: bulkUpload.token,
    });

    return response;
  } catch (error) {
    return null;
  }
};

let taskBulkUpload = null;
export const taskBulkUploadFunc = async (value) => {
  const url = "project-management/get-task-status";
  if (taskBulkUpload !== null) {
    taskBulkUpload.cancel("New Call made");
    taskBulkUpload = null;
  }
  taskBulkUpload = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: taskBulkUpload.token,
    });
    return response;
  } catch (error) {
    console.error("Error in taskBulkUploadFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let listDivision = null;
export const listDivisionFunc = async (value) => {
  const url = "project-management/list-team";
  if (listDivision !== null) {
    listDivision.cancel("New Call made");
    listDivision = null;
  }
  listDivision = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: listDivision.token,
    });
    return response;
  } catch (error) {
    console.error("Error in listDivisionFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let getUserHierarchy = null;
export const getUserHierarchyFunc = async (value) => {
  if (!store.getState().auth?.isAuthenticated) return null;
  const url = "project-management/get-company-meta";
  if (getUserHierarchy !== null) {
    getUserHierarchy.cancel("New Call made");
    getUserHierarchy = null;
  }
  getUserHierarchy = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: getUserHierarchy.token,
    });
    return response;
  } catch (error) {
    console.error("Error in getUserHierarchyFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let getUserHierarchyTop = null;
export const getUserHierarchyTopFunc = async (value) => {
  if (!store.getState().auth?.isAuthenticated) return null;
  const url = "project-management/get-company-meta";
  if (getUserHierarchyTop !== null) {
    getUserHierarchyTop.cancel("New Call made");
    getUserHierarchyTop = null;
  }
  getUserHierarchyTop = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: getUserHierarchyTop.token,
    });
    return response;
  } catch (error) {
    console.error("Error in getUserHierarchyTopFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let updateHierarch = null;
export const updateHierarchFunc = async (value) => {
  const url = "project-management/update-user-heirarchy";
  if (updateHierarch !== null) {
    updateHierarch.cancel("New Call made");
    updateHierarch = null;
  }
  updateHierarch = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: updateHierarch.token,
    });
    return response;
  } catch (error) {
    console.error("Error in updateHierarchFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let updateHierarchTask = null;
export const updateHierarchTaskFunc = async (value) => {
  const url = "project-management/get-task-status";
  if (updateHierarchTask !== null) {
    updateHierarchTask.cancel("New Call made");
    updateHierarchTask = null;
  }
  updateHierarchTask = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL_2 + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: updateHierarchTask.token,
    });
    return response;
  } catch (error) {
    console.error("Error in updateHierarchTaskFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let uploadHierarchy = null;
export const uploadHierarchyFunc = async (value) => {
  const url = "org/upload-company-heirarchy";
  if (uploadHierarchy !== null) {
    uploadHierarchy.cancel("New Call made");
    uploadHierarchy = null;
  }
  uploadHierarchy = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: uploadHierarchy.token,
    });
    return response;
  } catch (error) {
    console.error("Error in uploadHierarchyFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let uploadHierachyTask = null;
export const uploadHierachyTaskFunc = async (value) => {
  const url = "project/get-progress";
  if (uploadHierachyTask !== null) {
    uploadHierachyTask.cancel("New Call made");
    uploadHierachyTask = null;
  }
  uploadHierachyTask = axios.CancelToken.source();

  try {
    const response = await axios.post(BACKEND_URL + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: uploadHierachyTask.token,
    });
    return response;
  } catch (error) {
    console.error("Error in uploadHierachyTaskFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};

let checkProgressList = null;
export const checkProgressListFunc = async (value) => {
  const url = "project/get-progress";
  if (checkProgressList !== null) {
    checkProgressList.cancel("New Call made");
    checkProgressList = null;
  }
  checkProgressList = axios.CancelToken.source();
  try {
    const response = await axios.post(BACKEND_URL + url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"), // Add the token here
      },
      cancelToken: checkProgressList.token,
    });
    return response;
  } catch (error) {
    console.error("Error in checkProgressListFunc:", error); // Optional: Log the error for debugging
    return null;
  }
};
